import React, {useEffect, useState} from 'react';
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CircularProgress from '@mui/material/CircularProgress';
import useSumoTable from './useSumoTable';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SumoTable = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const { tableData, loading, error } = useSumoTable();



    if (loading) {
        return (
            <div className="rawContainerCenteredH">
                <CircularProgress />
            </div>
        );
    }

    if (error) {
        return (
            <MDBox p={3}>
                <MDTypography variant="h6" color="error" gutterBottom>
                    {t("sumo.table.error")} {error}
                </MDTypography>
            </MDBox>
        );
    }

    function handleRowClick(row) {
        navigate(`/sumo-display/graphs/${row.executionId}`);
    }

    return (
        <div className="diagramContainer">
            <div className="scrollable-100">
                <DataTable
                    table={tableData}
                    canSearch
                    onRowClick={(e) => handleRowClick(e)}
                />
            </div>
        </div>
    );
};

export default SumoTable;